import { useState } from 'react';

const IFS_TRACKS = [
  {
    id: 'ifs-1',
    title: 'IFS Meditation 1: Getting to know your parts',
    duration: '20 min',
    description:
      'A gentle introduction to meeting and understanding the different parts of yourself.',
    category: 'IFS',
  },
];

export default function HomeScreen({ onSelectTrack }) {
  const [activeTab, setActiveTab] = useState('IFS');

  return (
    <div className="home-screen">
      <header className="home-header">
        <h1 className="home-title">Mima</h1>
        <p className="home-subtitle">a space to come home to yourself</p>
        <nav className="tab-bar" role="tablist">
          {['IFS'].map((tab) => (
            <button
              key={tab}
              role="tab"
              aria-selected={activeTab === tab}
              className={`tab-button ${activeTab === tab ? 'active' : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </nav>
      </header>

      <main className="home-content">
        {activeTab === 'IFS' && (
          <div className="tab-content">
            <p className="intro-text">
              Internal Family Systems is a compassionate approach to understanding the
              different parts of yourself. These meditations guide you inward to meet and
              befriend the parts that shape your inner world.
            </p>
            <div className="track-list">
              {IFS_TRACKS.map((track) => (
                <button
                  key={track.id}
                  className="track-card"
                  onClick={() => onSelectTrack(track)}
                >
                  <div className="track-card-header">
                    <span className="track-title">{track.title}</span>
                    <span className="track-duration">{track.duration}</span>
                  </div>
                  <p className="track-description">{track.description}</p>
                </button>
              ))}
            </div>
          </div>
        )}
        <p className="dedication">Inspired by Aniara, the epic poem by Harry Martinson</p>
      </main>
    </div>
  );
}
